/* 130R — página de coleção (Tema 2, rodada 2, 18/10/2026; agente colecao). Carregado por sections/main-collection-page.liquid.
   1. Gaveta "Filtros" (#sidebarDrawer): o tema abre e fecha (classe is-open); aqui: foco, Esc, rolagem travada, aria-expanded,
      "Ver mais" das listas longas e não mandar campo de preço vazio.
   2. Barra do carro (Montadora / Modelo / Ano / Chassi): no celular fica recolhida num botão; teclado nas listas do assets/filter.js.
   3. Visualização em grade ou lista: marca o botão ativo (o tema não marca).
   4. Listagem por veículo (configuração da seção, desligada): com o carro salvo (localStorage r130_garage) e o filtro
      do metacampo r130.veiculos no Search & Discovery, mostra só as peças do carro; "ver todas" desliga nesta visita. */
(function () {
  'use strict';
  var raiz = document.documentElement;

  /* ---------- 1. gaveta de filtros ---------- */
  function iniciarGaveta() {
    var gaveta = document.getElementById('sidebarDrawer');
    if (!gaveta || !gaveta.classList.contains('r130-cf')) return;
    var abridores = document.querySelectorAll('.js-toggle-sb[data-role="open"]');
    var fechar = gaveta.querySelector('.r130-cf__fechar');
    var ultimoFoco = null;

    function aberta() { return gaveta.classList.contains('is-open'); }
    function sincronizar() {
      var a = aberta();
      abridores.forEach(function (b) { b.setAttribute('aria-expanded', a ? 'true' : 'false'); });
      raiz.classList.toggle('r130-cf-aberta', a);
      if (a) {
        if (!gaveta.contains(document.activeElement)) {
          ultimoFoco = document.activeElement;
          setTimeout(function () { (fechar || gaveta).focus(); }, 60);
        }
      } else if (ultimoFoco && gaveta.contains(document.activeElement)) {
        ultimoFoco.focus();
      }
    }
    new MutationObserver(sincronizar).observe(gaveta, { attributes: true, attributeFilter: ['class'] });
    abridores.forEach(function (b) { b.addEventListener('click', function () { ultimoFoco = b; }); });

    document.addEventListener('keydown', function (ev) {
      if (!aberta()) return;
      if (ev.key === 'Escape') { gaveta.classList.remove('is-open'); return; }
      if (ev.key !== 'Tab') return;
      // Foco preso na gaveta enquanto ela está aberta.
      var focaveis = Array.prototype.filter.call(
        gaveta.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, summary, [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null || el === document.activeElement; });
      if (!focaveis.length) return;
      var primeiro = focaveis[0], ultimo = focaveis[focaveis.length - 1];
      if (ev.shiftKey && document.activeElement === primeiro) { ev.preventDefault(); ultimo.focus(); }
      else if (!ev.shiftKey && document.activeElement === ultimo) { ev.preventDefault(); primeiro.focus(); }
    });

    gaveta.querySelectorAll('[data-r130-cf-mais]').forEach(function (b) {
      b.addEventListener('click', function () {
        var grupo = b.closest('.r130-cf__grupo');
        var abrir = !grupo.classList.contains('is-todos');
        grupo.classList.toggle('is-todos', abrir);
        b.setAttribute('aria-expanded', abrir ? 'true' : 'false');
        b.textContent = abrir ? 'Ver menos' : b.getAttribute('data-texto') || b.textContent;
      });
      b.setAttribute('data-texto', b.textContent);
    });

    var form = gaveta.querySelector('[data-r130-cf-form]');
    if (form) {
      form.addEventListener('submit', function () {
        form.querySelectorAll('input[type="number"]').forEach(function (i) { if (i.value === '') i.disabled = true; });
      });
    }
  }

  /* ---------- 2. barra do carro ---------- */
  function iniciarBarra() {
    var barra = document.querySelector('[data-r130-col-barra]');
    if (!barra) return;
    var botao = barra.querySelector('.r130-col-barra__abrir');
    barra.classList.add('r130-js');
    if (botao) {
      botao.hidden = false;
      botao.addEventListener('click', function () {
        var abrir = !barra.classList.contains('is-aberta');
        barra.classList.toggle('is-aberta', abrir);
        botao.setAttribute('aria-expanded', abrir ? 'true' : 'false');
        if (abrir) {
          var primeiro = barra.querySelector('.chosen-container.active .chosen-single');
          if (primeiro) primeiro.focus();
        }
      });
    }

    // Teclado nas listas (Montadora, Modelo, Ano): o assets/filter.js só trata clique.
    barra.querySelectorAll('.chosen-container').forEach(function (campo) {
      var botaoCampo = campo.querySelector('.chosen-single');
      var gaveta = campo.querySelector('.chosen-drop');
      var lista = campo.querySelector('.chosen-results');
      var busca = campo.querySelector('.chosen-search input');
      if (!botaoCampo || !gaveta || !lista) return;
      function itens() { return Array.prototype.filter.call(lista.children, function (li) { return li.style.display !== 'none'; }); }
      function marcar() {
        Array.prototype.forEach.call(lista.children, function (li) {
          if (!li.hasAttribute('role')) { li.setAttribute('role', 'option'); li.setAttribute('tabindex', '-1'); }
        });
      }
      new MutationObserver(marcar).observe(lista, { childList: true });
      new MutationObserver(function () {
        var a = gaveta.classList.contains('active');
        botaoCampo.setAttribute('aria-expanded', a ? 'true' : 'false');
        if (a && busca && campo.contains(document.activeElement)) setTimeout(function () { busca.focus(); }, 30);
      }).observe(gaveta, { attributes: true, attributeFilter: ['class'] });
      function mover(de, passo) {
        var l = itens(); if (!l.length) return;
        var i = l.indexOf(de) + passo;
        if (i < 0) { if (busca) busca.focus(); return; }
        l[Math.min(i, l.length - 1)].focus();
      }
      campo.addEventListener('keydown', function (ev) {
        var alvo = ev.target;
        if (ev.key === 'Escape' && gaveta.classList.contains('active')) {
          gaveta.classList.remove('active'); botaoCampo.focus(); ev.stopPropagation(); return;
        }
        if (alvo === busca) {
          if (ev.key === 'ArrowDown') { ev.preventDefault(); mover(null, 1); }
          else if (ev.key === 'Enter') { ev.preventDefault(); var l = itens(); if (l.length) l[0].click(); }
          return;
        }
        if (alvo.parentNode === lista) {
          if (ev.key === 'ArrowDown') { ev.preventDefault(); mover(alvo, 1); }
          else if (ev.key === 'ArrowUp') { ev.preventDefault(); mover(alvo, -1); }
          else if (ev.key === 'Enter' || ev.key === ' ') {
            ev.preventDefault(); alvo.click();
            var prox = campo.nextElementSibling && campo.nextElementSibling.querySelector('.chosen-single, input');
            if (prox) setTimeout(function () { prox.focus(); }, 30);
          }
        }
      });
    });
  }

  /* ---------- 3. grade ou lista ---------- */
  function iniciarVista() {
    var lista = document.getElementById('grid_style_list');
    if (!lista) return;
    var itens = lista.querySelectorAll('.view-item');
    function marcar(ativo) {
      itens.forEach(function (li) {
        var on = li === ativo;
        li.classList.toggle('active', on);
        var b = li.querySelector('button'); if (b) b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    itens.forEach(function (li) { li.addEventListener('click', function () { marcar(li); }); });
    var lista2 = /(^|;\s*)arn-mode-view=/.test(document.cookie);
    marcar(itens[lista2 && itens[1] ? 1 : 0]);
  }

  /* ---------- 4. listagem por veículo (desligada por padrão) ---------- */
  function norm(s) {
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/\s+/g, ' ').trim();
  }
  function carroSalvo() {
    try { var c = JSON.parse(localStorage.getItem('r130_garage')); return c && c.brand && c.model && c.year ? c : null; } catch (e) { return null; }
  }
  function iniciarVeiculo() {
    var aviso = document.querySelector('[data-r130-col-veic]');
    if (!aviso) return;
    var CHAVE_TODAS = 'r130_veic_todas';
    var param = aviso.getAttribute('data-param');
    var ativo = aviso.getAttribute('data-ativo');
    var txt = aviso.querySelector('[data-r130-col-veic-txt]');
    var todas = aviso.querySelector('[data-r130-col-veic-todas]');
    var valores = [];
    try { valores = JSON.parse(aviso.getAttribute('data-valores') || '[]') || []; } catch (e) { valores = []; }

    // "SANTA FÉ" -> "Santa Fé", "HB20" e "IX35" ficam como estão (mesmo jeito do botão Meu carro).
    function nomeCarro(c) {
      var m = String(c.model).split(' ').map(function (p) { return /\d/.test(p) ? p.toUpperCase() : p.charAt(0).toUpperCase() + p.slice(1).toLowerCase(); }).join(' ');
      return m + ' ' + c.year;
    }
    function valorDoCarro(c) {
      var alvo = norm(c.brand + ' ' + c.model + ' ' + c.year);
      for (var i = 0; i < valores.length; i++) if (norm(valores[i]) === alvo) return valores[i];
      return null;
    }
    function urlCom(valor) {
      var u = new URL(location.href);
      u.searchParams.delete('page');
      u.searchParams.delete(param);
      if (valor) u.searchParams.append(param, valor);
      return u.toString();
    }
    function mostrar(html, mostrarTodas) {
      txt.innerHTML = html;
      if (todas) todas.hidden = !mostrarTodas;
      aviso.hidden = false;
    }
    function esc(s) { return String(s).replace(/[&<>"']/g, function (ch) { return '&#' + ch.charCodeAt(0) + ';'; }); }

    if (todas) todas.addEventListener('click', function () { try { sessionStorage.setItem(CHAVE_TODAS, '1'); } catch (e) {} });

    function aplicar(trocou) {
      var c = carroSalvo();
      if (ativo) {
        // Já filtrado pelo veículo (veio da URL). Se o carro salvo mudou, troca o filtro.
        if (trocou && c) {
          var v = valorDoCarro(c);
          if (v && norm(v) !== norm(ativo)) location.replace(urlCom(v));
          else if (!v) location.replace(urlCom(null));
        } else if (trocou && !c) location.replace(urlCom(null));
        return;
      }
      if (!c || !valores.length || aviso.hasAttribute('data-tags')) return;
      var desligado = false;
      try { desligado = sessionStorage.getItem(CHAVE_TODAS) === '1'; } catch (e) {}
      if (trocou) { try { sessionStorage.removeItem(CHAVE_TODAS); } catch (e) {} desligado = false; }
      var valor = valorDoCarro(c);
      if (!valor) {
        mostrar('Nenhuma peça desta lista está marcada para o <strong>' + esc(nomeCarro(c)) + '</strong>. Mostrando todas.', false);
        return;
      }
      if (desligado) {
        mostrar('Mostrando todas as peças. <a class="r130-col-veic__link" href="' + esc(urlCom(valor)) + '">Ver só as do ' + esc(nomeCarro(c)) + '</a>', false);
        return;
      }
      location.replace(urlCom(valor));
    }
    aplicar(false);
    // O modal "Meu carro" avisa quando o carro muda (snippets/130r-garagem-virtual.liquid).
    document.addEventListener('r130:garagem', function () { aplicar(true); });
  }

  function iniciar() { iniciarGaveta(); iniciarBarra(); iniciarVista(); iniciarVeiculo(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
